import { AuthorResponse } from "./common";
import { EntityType } from "./logs";
import { FeedbackStatus } from "./feedback";
import { LabelColorOptions } from "@primer/react";

export type ComplaintOrderingField = "created_at" | "-created_at";

export interface ComplaintResponse {
  id: string;
  createdAt: string;
  text: string;
  targetEntityType: EntityType;
  targetEntityId: string;
  user: AuthorResponse;
  status: FeedbackStatus;
}

export interface ComplaintsListRequest {
  limit?: number;
  offset?: number;
  ordering?: ComplaintOrderingField;
  search?: string;
  status?: FeedbackStatus;
}

export function getColorVariantForComplaintTopic(
  topic: EntityType
): LabelColorOptions {
  switch (topic) {
    case "ad":
      return "done";
    case "user":
      return "accent";
    case "comment":
      return "primary";
    case "chat":
      return "success";
    case "review":
      return "severe";
    case "post":
      return "primary";
    case "topic":
      return "danger";
    case "profile":
    case "seller":
      return "attention";
    case "settings":
      return "done";
    case "system":
      return "sponsors";
    default:
      return "primary";
  }
}

export function getComplaintFromString(topic: EntityType): string {
  switch (topic) {
    case "ad":
      return "На объявление";
    case "user":
      return "На пользователя";
    case "comment":
      return "На комментарий в объявлении";
    case "chat":
      return "На комментарий в чате";
    case "review":
      return "На отзыв";
    case "post":
      return "На комментарий в форуме";
    case "topic":
      return "На тему";
    case "profile":
    case "seller":
      return "На продавца";
    case "settings":
      return "На настройки";
    case "system":
      return "На систему";
    default:
      return "";
  }
}
